import React from 'react'
import './WelcomeTitle.css'

function WelcomeTitle({ isMobile }) {
  
    if (isMobile) {
      return (
        <div className="welcome-title">
          <div className="welcome-title-text">
            Get fast solutions to complex scenario with <span className="welcome-title-highlight">Scenario AI</span>
          </div>
          <div className="welcome-title-subtext">
            Locate the right loan programs in seconds, with answers straight from the guidelines.
          </div>
        </div>
      )
    }

    return (
      <div className="welcome-title">
        <div className="welcome-title-text">
          Get fast solutions to complex scenario
        </div>
        <div className="welcome-title-text">
          with <span className="welcome-title-highlight">Scenario AI</span>
        </div>
        <div className="welcome-title-subtext">
          Locate the right loan programs in seconds, with answers straight from the guidelines.
        </div>
      </div>
    )
}

export default WelcomeTitle